import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import Swal from 'sweetalert2';
import {ConceptoService, PageBusquedaObject, Ctbcon} from '../concepto-service.service';
import { LoginService } from '../../../login/login.service';

@Component({
  selector: 'app-formulario-concepto',
  templateUrl: './formulario-concepto.component.html',
  styleUrls: ['./formulario-concepto.component.css'],
  preserveWhitespaces: true
})
export class FormularioConceptoComponent implements OnInit {

  public id_param: number;
  public cc: Ctbcon = new Ctbcon();
  errors: String[];
  busqueda: PageBusquedaObject = new PageBusquedaObject();

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public loginService: LoginService,
    private service: ConceptoService
  ) { }

  ngOnInit() {
    this.busqueda.criteriaSearch = {};
    this.activatedRoute.params.subscribe(params => {
      this.id_param = params['id'];
      if (this.id_param) {
        this.service.getConcepto(this.id_param).subscribe(response => {
          this.cc = response.contenido;
        }, err => {
          if (err.error.mensaje == null || '' || undefined) {
            err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
          }
          Swal.fire({
            icon: 'error',
            title: 'TNK Ledger',
            text: err.error.mensaje
          })
          console.log(err);
        });
      }
    });
  }
  ValidaSoloNumeros() {
    var e = e || window.event;
    if ((e.keyCode < 46) || (e.keyCode > 57)) {
      e.returnValue = false;
      e.preventDefault();
    }
  }

  crear() {
    this.cc.gralUsrCreaId = this.loginService.usuario.id as number;
    /*this.bn.gralUsrBajaId = this.loginService.usuario.id as number;*/
    this.cc.gral_emp_id = this.loginService.empresa as number;
    this.service.post(this.cc).subscribe(response => {
      Swal.fire(response.mensaje);
      this.router.navigate(['/contabilidad/catalogo/ctb-con']);
    }, err => {
      if (err.error.mensaje == null || '' || undefined) {
        err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
      }
      this.errors = err.error.error;
      Swal.fire({
        icon: 'error',
        title: 'TNK Ledger',
        text: err.error.mensaje
      })
    });
  }

  actualizar() {
    this.cc.gralUsrActualizaId = this.loginService.usuario.id as number;
    this.cc.gral_emp_id = this.loginService.empresa as number;
    this.service.put(this.cc).subscribe(response => {
      Swal.fire(response.mensaje);
      this.router.navigate(['/contabilidad/catalogo/ctb-con']);
    }, err => {
      if (err.error.mensaje == null || '' || undefined) {
        err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
      }
      this.errors = err.error.error;
      Swal.fire({
        icon: 'error',
        title: 'TNK Ledger',
        text: err.error.mensaje
      })
    });
  }

}
